import React, { Component } from 'react'
import { string, func, bool } from 'prop-types'
import IntlTelInput from 'react-intl-tel-input'
import 'react-intl-tel-input/dist/libphonenumber.js'
import 'react-intl-tel-input/dist/main.css'
import { stores, view } from '../../../stores'
import { isPhone } from '../../../utilities/validators'

class PhoneInputComponent extends Component {
  constructor ({ value }) {
    super()
    this.state = {
      ...this.parseValue(value),
      isValid: true,
      errors: []
    }
  }

  parseValue (value) {
    return {
      value: value && value.hasOwnProperty('phone') ? value.phone : (value || ''),
      dialCode: value && value.hasOwnProperty('dialCode') ? value.dialCode : ''
    }
  }

  /**
   * Compare 2 phones - this is mostly due to a bug
   * with the PhoneInput when updating a value once the component is loaded
   * You can deactivate the call to this in componentWillReceiveProps and update your profile picture in the account
   * Once the account is reloaded from the API - The value overrides the input and the component don't parse the dialcode
   * like he does on first rendering.
   * This IntlTelInput should be replaced altogether
   * @param {value} value to update
   * @return {boolean} true if both are true
   */
  compare (value) {
    if (typeof value === 'string') {
      return value === this.format(this.state.value, this.state.dialCode)
    } else if (value.phone && value.dialCode) {
      return value.phone === this.state.value && value.dialCode === this.state.dialCode
    }
  }

  format (phone, dialCode) {
    return `+${dialCode}${phone.replace(/[\s.]+/gi, '')}`
  }

  componentWillReceiveProps ({ value }) {
    if (value && !this.compare(value)) {
      this.setState(this.parseValue(value))
    }
  }

  validate (value) {
    // Warning: If given, value is more up to date than the state (updated @ next tick)
    // Thus we check if undefined, as an empty value is a possible value
    value = value === undefined ? this.refs[this.props.name].state.value : value
    let valid = this.refs[this.props.name].isValidNumber(value) && isPhone(value)
    if (!valid && !value) {
      valid = !this.props.required
    }
    const errors = valid ? [] : [{ message: 'Numéro de téléphone incorrect' }]
    return { isValid: valid, errors: errors }
  }

  handleChange (value, infos) {
    const { isValid, errors } = this.validate(value)
    const phone = value
    const dialCode = infos.dialCode

    this.setState({ phone, dialCode })

    if (this.props.onChange) {
      this.props.onChange({ phone: phone, dialCode: dialCode, value: this.format(phone, dialCode) }, isValid)
    }

    clearTimeout(this._rulesValidationTimeout)
    this._rulesValidationTimeout = setTimeout(() => {
      this.setState({ isValid, errors })
    }, 500)
  }

  /*
   * Validation handler called on value change
   */
  handleValidation () {
    const result = this.validate()
    this.setState({...result})
    return { label: this.props.label, ...result }
  }

  render () {
    const { bold, name, label, className, placeholder } = this.props
    const { isValid, errors } = this.state

    if (!stores.countries.initialized) {
      return null
    }

    return (<div className='clearfix'>
      <label style={(bold) ? {fontWeight: 500} : {}} className={'form__label' + (!isValid ? ' form__label--error' : '')} htmlFor={name} >{label}</label>
      <IntlTelInput
        preferredCountries={['fr']}
        value={this.state.value}
        countriesData={stores.countries.countries}
        onPhoneNumberChange={(valid, value, infos) => this.handleChange(value, infos)}
        onSelectFlag={(value, infos) => this.handleChange(value, infos)}
        placeholder={placeholder}
        css={className ? [className, 'intl-tel-input form__input' + (!isValid ? ' form__input-error' : '')] : ['intl-tel-input form__input' + (!isValid ? ' form__input-error' : '')]}
        utilsScript={'libphonenumber.js'}
        fieldId={name}
        ref={name}
        id={name}
      />
      {
        !isValid && errors.length
        ? <p className='form__errormessage' >{errors[0].message}</p>
        : ''
      }
    </div>)
  }
}
PhoneInputComponent.propTypes = {
  bold: bool,
  name: string,
  label: string,
  placeholder: string,
  className: string,
  onChange: func,
  required: bool
}

export const PhoneInput = view(PhoneInputComponent)



// WEBPACK FOOTER //
// ./src/components/ui/inputs/PhoneInput.js